import CookieUtils from "./CookieUtils";
import AppContext from "@/libs/esg-acsp-core-vue-lib/utils/AppContext";
import Platform from "@/libs/esg-acsp-core-vue-lib/utils/Platform";

const GrayEnvUtil = {};

/**
 * 目标包是否是灰度
 * @returns {boolean}
 */
GrayEnvUtil.isToGray = () => CookieUtils.getCookie("grayScale") === "1";

/**
 * 当前页面是否是灰度包
 * @returns {boolean}
 */
GrayEnvUtil.isInGray = () => {
  const { pathname = "" } = location || {};
  return /^\/g\//.test(pathname);
};

/**
 * 将link切换成灰度
 * @param link
 */
GrayEnvUtil.switchLinkToGray = (link) => {
  if (Platform.isMoible()) {
    return link.replace("/acsp/", "/g/");
  }
  return link.replace("/web/", "/g/");
};
/**
 * 将link切换成常规
 * @param link
 */
GrayEnvUtil.switchLinkToGeneral = (link) => {
  if (Platform.isMoible()) {
    return link.replace("/g/", "/acsp/");
  }
  return link.replace("/g/", "/web/");
};

GrayEnvUtil.replace = (fullPath) => {
  if (!GrayEnvUtil.switchIfGray(fullPath)) {
    AppContext.$router.replace(fullPath);
  }
};

/**
 * 常规与灰度环境的切换
 * 需要在以下逻辑触发：路由切换、登录成功、切换卡号
 * @param route router.beforeEach中传to路由，其他地方调用不用传
 * @return {boolean} true:需要环境切换；false:不需要切换
 */
GrayEnvUtil.switchIfGray = (fullPath) => {
  // 开发模式不跳转
  if (process.env.NODE_ENV === "development") return false;

  const isToGray = GrayEnvUtil.isToGray();
  const isInGray = GrayEnvUtil.isInGray();

  if (isToGray === isInGray) {
    return false;
  }

  //需要切换环境，用location重新加载
  const { href, origin } = location;
  let targetLink = "";
  if (fullPath) {
    let path = AppContext.$router.options.base + fullPath;
    path = path.replace(/\/\//i, "/");
    targetLink = origin + path;
  } else {
    targetLink = href;
  }

  if (isInGray && !isToGray) {
    // 灰 -> 常
    targetLink = GrayEnvUtil.switchLinkToGeneral(targetLink);
  } else if (!isInGray && isToGray) {
    // 常 -> 灰
    targetLink = GrayEnvUtil.switchLinkToGray(targetLink);
  }
  console.log("切换环境", targetLink);
  location.replace(targetLink);
  return true;
};

export default GrayEnvUtil;
